import { FC } from 'react';

import { CheckboxFilterTree } from '@telialt/common-checkbox-filter-tree/src/CheckboxFilterTree';
import { ResponsiveLabel } from '@telialt/common-checkbox-filter-tree/src/LabelComponents';
import { FilterNode } from '@telialt/common-checkbox-filter-tree/src/model';
import { useTranslations } from '@telialt/common-cms/src/useTranslations';

import { FacetTerms, FilterTerms } from '../../model';
import { FacetItem } from '../FacetItem/FacetItem';
import { FacetContainer } from './Facets.styles';

type Props = {
    facet: FacetTerms;
    filter?: FilterTerms;
    onChange: (fieldName: string, filter?: FilterTerms) => void;
    showCount?: boolean;
};

const mapFacetItemsToFilterNodes = (showCount: boolean, items?: FacetTerms['items']): FilterNode[] =>
    items?.map((item) => ({
        title: item.title,
        count: showCount ? item.count : undefined,
    }));

export const TermsFacet: FC<Props> = ({ facet, filter, onChange, showCount }) => {
    const { t } = useTranslations();

    const filters = mapFacetItemsToFilterNodes(showCount, facet.items);

    const handleSelect = (values: string[][]) => {
        onChange(facet.key, values.length > 0 ? values.map((value) => value[0]) : undefined);
    };

    const selected = filter?.map((term) => [term]);

    return (
        <FacetItem id={facet.key} label={facet.label} facetType="terms">
            <FacetContainer>
                <CheckboxFilterTree
                    selected={selected}
                    filters={filters}
                    searchEnabled={facet.items.length > 10}
                    searchPlaceholder={t['search.results.facets.search_placeholder']}
                    searchAllyLabel={t['search.results.facets.search_a11y_label']}
                    searchClearButtonAllyLabel={t['search.results.facets.search_clear_label']}
                    maxVisibleItems={5}
                    showLessText={t['search.results.facets.collapse']}
                    showMoreText={t['search.results.facets.expand']}
                    onSelect={handleSelect}
                    Label={ResponsiveLabel}
                />
            </FacetContainer>
        </FacetItem>
    );
};
